import { Lock } from 'lucide-react'

export const ReadOnlyBadge = () => {
  return (
    <div className='flex items-center gap-2 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-lg'>
      <Lock className='h-4 w-4 text-amber-600' />
      <span className='text-sm font-medium text-amber-800'>Read Only</span>
    </div>
  )
}
